export const findIndexOrUndefined = <T>(arr: T[], predicate: (value: T, index: number, obj: T[]) => boolean): number | undefined => {
    const index = arr.findIndex(predicate);
    return index !== -1 ? index : undefined;
}
